/*
 * Visual do "Leve também" do Selleasy (snippets/product-addon-offer.liquid), na página de produto e no
 * carrinho lateral. O app monta o cartão e cuida do preço e do carrinho; aqui entram a etiqueta "Oferta
 * especial", nos kits de refil a frase "Garanta 1 ano de água alcalina" e, quando o produto tem preço
 * "De", o desconto total a partir dele (showFullPrice).
 * Também troca os rótulos de preço que o app escreve em inglês ("Regular price", "Sale price"),
 * lidos pelo leitor de tela, pelos textos do tema.
 */
(() => {
  const strings = window.acqualiveAddonOffer || {};
  const tagIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z"/><circle cx="7" cy="7" r="1.5"/></svg>';

  const element = (tag, className, html) => {
    const node = document.createElement(tag);
    node.className = className;
    node.innerHTML = html;
    return node;
  };

  const escapeHtml = (text) => {
    const node = document.createElement('span');
    node.textContent = text ?? '';
    return node.innerHTML;
  };

  // Rótulos em inglês que o Selleasy põe no cartão (texto oculto ou aria-label) → textos do tema
  const labels = [
    [/^\s*regular price\s*$/i, strings.regularPrice],
    [/^\s*sale price\s*$/i, strings.salePrice],
  ].filter(([, text]) => text);

  const translate = (value) => {
    // "Kit Refil Fresh Nanno V checkbox" (aria-label do app) → "Levar também: Kit Refil Fresh Nanno V"
    const checkbox = strings.select && value.match(/^\s*(.+?)\s+checkbox\s*$/i);
    if (checkbox) return strings.select.replace('__PRODUCT__', checkbox[1]);
    const match = labels.find(([pattern]) => pattern.test(value));
    return match ? match[1] : null;
  };

  function translateLabels(card) {
    if (!labels.length && !strings.select) return;
    const walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const text = translate(node.nodeValue);
      if (text) node.nodeValue = text;
    }
    card.querySelectorAll('[aria-label]').forEach((el) => {
      const text = translate(el.getAttribute('aria-label'));
      if (text) el.setAttribute('aria-label', text);
    });
  }

  // Preço "De" do produto oferecido, uma busca por produto durante a visita
  const products = new Map();
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) =>
    `R$ ${(cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  /*
   * Em campanha, o produto oferecido tem preço "De" (ex.: kit de refil De R$ 577 por R$ 532) e o desconto
   * do app é calculado para fechar o valor sobre o preço cheio (R$ 155 → R$ 377). O app mostraria
   * "R$ 532 riscado, -R$ 155"; aqui o riscado vira o "De" e o selo, o desconto total (-R$ 200).
   */
  async function showFullPrice(card) {
    const host = card.closest('[lb-product-handle]');
    const sale = card.querySelector('.lb-price-sale-price');
    const compare = card.querySelector('.lb-price-compare-price');
    const saleCents = Number(sale?.getAttribute('lb-default-price'));
    if (!host || !compare || !saleCents) return;

    const variantId = host.getAttribute('lb-variant-id');
    const key = `${variantId}:${saleCents}`;
    if (card.dataset.acqFullPrice === key) return;
    card.dataset.acqFullPrice = key;

    const handle = host.getAttribute('lb-product-handle');
    if (!products.has(handle)) {
      products.set(
        handle,
        fetch(`${root}products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    const product = await products.get(handle);
    const variant = product?.variants?.find((item) => String(item.id) === variantId) || product?.variants?.[0];
    const compareAt = variant?.compare_at_price;
    if (!compareAt || compareAt <= variant.price || compareAt <= saleCents) return;
    if (card.dataset.acqFullPrice !== key) return; // o app remontou o cartão enquanto buscava

    compare.textContent = money(compareAt);
    compare.setAttribute('lb-price', money(compareAt));
    const discount = card.querySelector('.lb-price-discount');
    if (discount) discount.textContent = `-${money(compareAt - saleCents)}`;
  }

  function enhance(card) {
    translateLabels(card);
    showFullPrice(card);

    const content = card.querySelector('.lb-cta-cont');
    if (!content) return;

    if (strings.badge && !content.querySelector(':scope > .acq-addon__badge')) {
      content.prepend(element('span', 'acq-addon__badge', `${tagIcon}${escapeHtml(strings.badge)}`));
    }

    const handle = card.closest('[lb-product-handle]')?.getAttribute('lb-product-handle') || '';
    if (strings.refil && handle.startsWith('kit-refil') && !content.querySelector(':scope > .acq-addon__hint')) {
      content.appendChild(element('p', 'acq-addon__hint', escapeHtml(strings.refil)));
    }
  }

  let scheduled = false;
  const scan = () => {
    scheduled = false;
    // "Leve também" (.lb-addon-cont), na página de produto e no carrinho lateral
    document.querySelectorAll('.lb-addon-cont .lb-flat-card').forEach(enhance);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(scan, 50); // setTimeout, não requestAnimationFrame: este para em aba oculta
  };

  // O app monta o cartão quando o bloco entra na tela e remonta ao trocar de variante
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
